import type { Ref } from 'react'
import { useIntl } from 'react-intl'
import styled, { keyframes } from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'
import IconButton from 'LuxKit/Button/IconButton'
import SolidMicrophoneIcon from 'LuxKit/Icons/solid/SolidMicrophoneIcon'
import composerVoiceMessages from './composerVoiceMessages'

const pulse = keyframes`
  0% { transform: scale(0.85); opacity: 1; }
  100% { transform: scale(1.35); opacity: 0; }
`

const PulseRing = styled.span`
  position: relative;
  display: inline-flex;
  border-radius: ${props => props.theme.borderRadius.round};

  &.pulsing::before {
    content: '';
    position: absolute;
    inset: ${rem(-4)};
    border-radius: inherit;
    border: ${rem(2)} solid ${props => props.theme.palette.highlight.primary.normalForeground};
    pointer-events: none;
    animation: ${pulse} 1.6s ease-out infinite;
  }
`

interface Props {
  onClick: () => void
  disabled?: boolean
  isEmphasised?: boolean
  ref?: Ref<HTMLSpanElement>
}

function ComposerMicrophoneButton({ onClick, disabled = false, isEmphasised = false, ref }: Props) {
  const intl = useIntl()

  return (
    <PulseRing ref={ref} className={clsx({ pulsing: isEmphasised })}>
      <IconButton
        kind="tertiary"
        shape="circle"
        size="small"
        onClick={onClick}
        disabled={disabled}
        aria-label={intl.formatMessage(composerVoiceMessages.microphoneLabel)}
      >
        <SolidMicrophoneIcon />
      </IconButton>
    </PulseRing>
  )
}

export default ComposerMicrophoneButton
